module.exports = __webpack_public_path__ + "img/navigation.432d5bf2.png";